<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<a-select  style="width:11rem; margin-right: 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  @change="queryData">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-button size="small"    @click="readMeter4Neighbor"  :loading="neighborSubmitFlag" :disabled="allFlag">抄小区</a-button>
			<a-button size="small" style="margin: 0 0.625rem"   v-if="false" @click="readMeter4All" :loading="allSubmitFlag" :disabled="allFlag">抄全部小区</a-button>
			<a-button size="small" style="margin: 0 0.625rem" type="danger"  @click="finishTask" :loading="finishLoading" >结束任务</a-button>
			<label style="margin-left:0.625rem ;">集中器</label>
			<a-select  style="width:8.5rem; margin: 0 0.625rem;font-size: 0.6875rem;" option-filter-prop="children"  :filter-option="filterOption" 
							show-search  label-in-value   v-model="theGprs" @change="queryMeters">
				<a-select-option v-for="(item,index) in gprsList" :key="item.pId" :value="item.pId">{{item.gprsAddr}}</a-select-option>
			</a-select>
			<label>采集器</label>
			<a-select style="width:8.5rem; margin: 0 0.625rem;font-size: 0.6875rem;" label-in-value  v-model="theCollector">
				<a-select-option v-for="(item,index) in collectorList" :key="item.collectorAddr" :value="item.collectorAddr">{{item.collectorAddr}}</a-select-option>
			</a-select>
			<a-button size="small"   @click="readMeter4Collector" :loading="collectorSubmitFlag" :disabled="allFlag">抄采集器</a-button>
			<a-button size="small"   @click="queryFailList" style="margin: 0 0.625rem 0 1.2rem;" :disabled="allFlag">选中故障表</a-button>
			<a-button size="small"    @click="readMeter4Chosed" :loading="chosedSubmitFlag" style="margin: 0 2rem 0 0;"  :disabled="allFlag">抄选中表</a-button>
			 <a-checkbox  @change="lihuCheck" style="font-size: 0.65rem;margin-right: 0.3rem;">
				 只看立户表
			 </a-checkbox>
			<a-button type="primary" size="small" style="margin: 0 0.625rem"  @click="queryListData" :loading="loading" >刷新页面</a-button>
			<a-dropdown placement="bottomCenter" :disabled="allFlag">
				<a-button  size="small">导出当前小区</a-button>
				<a-menu slot="overlay" @click="exportNeighbor">
					<a-menu-item  v-for="(item,index) in exportTypeList" :key="item.pid">
						{{item.exportname}}
					</a-menu-item>
				</a-menu>
			</a-dropdown>
			<a-dropdown placement="bottomCenter" :disabled="loading">
				<a-button   size="small" style="margin: 0 0.625rem;">导出全部</a-button>
				<a-menu slot="overlay" @click="exportAll">
					<a-menu-item  v-for="(item,index) in exportTypeList" :key="item.pid">
						{{item.exportname}}
					</a-menu-item>
				</a-menu>
			</a-dropdown>
			<a-dropdown placement="bottomCenter" :disabled="theNeighbor==undefined||theNeighbor==null">
				<a-button   size="small" style="margin: 0 0.625rem;">搜索和过滤</a-button>
				<a-menu slot="overlay" @click="searchIt">
					<a-menu-item  v-for="(item) in sortList" :key="item.id">
						{{item.name}}
					</a-menu-item>
				</a-menu>
			</a-dropdown>
			<a-button size="small"   @click="showImportFlag = true" :disabled="theNeighbor==undefined||theNeighbor==null">对比上传</a-button>
			<a-input-search v-model ="theApId" placeholder="根据给水号查询"   allowClear
								 enter-button @search="queryDataByApId"  style="width: 11rem;"/>
			
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"  :cell-style="cellClassName" ref="mTable" show-overflow="title" size="mini" stripe
						  resizable  :loading="loading"  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						  :sort-config="{multiple: true,trigger: 'cell'}" :checkbox-config="{trigger: 'row', highlight: true, range: true}"  row-id="MID">
				<vxe-table-column type="seq" width="45"></vxe-table-column>
				<vxe-table-column type="checkbox" width="40"></vxe-table-column>
				<vxe-table-column title="小区" field="neighborId" width="auto" :formatter="getTheNeighborName"></vxe-table-column>
				<vxe-table-column title="用户号" field="customerNum"  sortable></vxe-table-column>
				<vxe-table-column title="支付宝缴费号" field="PID"  v-if="check4All == false" sortable></vxe-table-column>
				<vxe-table-column title="给水号" field="APID"  sortable v-if="check4All == true"></vxe-table-column>
				<vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
				<vxe-table-column title="余额" field="CustomerBalance"  v-if="check4All == false" sortable></vxe-table-column>
				<vxe-table-column title="口径" field="MeterTypeName" width="80" sortable sort-by="MeterMM"></vxe-table-column>
				<vxe-table-column title="集中器" field="GPRSAddr"  sortable width="120"></vxe-table-column>
				<vxe-table-column title="采集器地址" field="CollectorAddr" sortable  width="120"></vxe-table-column>
				<vxe-table-column title="表地址" field="MeterAddr" sortable  width="120"></vxe-table-column>
				<vxe-table-column title="表状态" field="MeterState"  :formatter="getMeterState" sortable></vxe-table-column>
				<vxe-table-column title="扣费读数" field="deread"  sortable></vxe-table-column>
				<vxe-table-column title="表读数" field="readdata"  sortable></vxe-table-column>
				<vxe-table-column title="对比量" field="contrastData"  sortable></vxe-table-column>
				<vxe-table-column title="抄表时间" field="readtime"  :formatter="getTimeFormatter" sortable width="140"></vxe-table-column>
				 <vxe-table-column title="电压" field="voltage" width="60" v-if="check4All == true"></vxe-table-column>
				<vxe-table-column title="操作" field="MID" width="270">
					<template #default="{ row }">
						<a-button :disabled="row.is_fault == '1' || row.GPRSAddr == '00000000000000' || row.GPRSProtocol == '4'" size="small"  type="link" @click="readMeterSingle(row)" :loading="singleSubmiting && theObj ==row">抄表</a-button>
						<a-button size="small"  type="link" @click="editReadData(row)">修改</a-button>
						<a-button size="small"  type="link" @click="readHistory(row)">历史读数</a-button>
						<a-button size="small" type="link" @click="exportData(row)">导出当前</a-button>
						<!-- <a-button size="small" type="link" @click="exportData(row)" v-if="departId == 133 && row.ValveState== 1">关阀</a-button> -->
						<a-button size="small" type="link" @click="openValve(row)" v-if="departId == 133 && row.ValveState== 0">关阀</a-button>
						<a-button size="small" type="link" @click="openValve(row)" v-if="departId == 133 && row.ValveState== 1">开阀</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<a-modal title="修改表读数"  :visible="showUpdateReadFlag"  @ok="updateMeterRead" @cancel="cancelUpdateMeterRead" centered
					cancel-text="取消" ok-text="提交" :confirm-loading="updateSubmitFlag">
			<label>请输入表读数</label>
			<a-input-number  v-model="theUpdateMeterRead" :min="0" :precision="0" style="margin-left: 1.25rem;width: 21rem;"/>
		</a-modal>
		<a-drawer title="历史读数"  :visible="showHistoryFlag" width="520" @close="showHistoryFlag = false" :destroyOnClose="true"  :maskClosable="true">
			<MeterReadHistory  :theId="theObj.MID"/>
		</a-drawer>
		<a-modal :title="theSearchTitle"  :visible="showSearchFlag"  @ok="doSearchIt" @cancel="showSearchFlag=false" centered
					cancel-text="取消" ok-text="提交" :confirm-loading="searchSubmitFlag">
			<label>{{theSearchTitle}} :</label>
			<a-input  v-model="searchText"  style="margin-left: 1rem;width: 21rem;"/>
		</a-modal>
		<vxe-modal ref="mModal" v-model="showImportFlag" title="巡检导入" width="450" height="350"
								resize destroy-on-close :mask="false" :lock-view="false" :show-zoom="true" :position="{top:250}">
			<a-upload :file-list="fileList" :remove="handleFileRemove" :before-upload="beforeUpload" :disabled="importLoading"
							accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
				<a-button type = "default" icon = "upload">选择文件 </a-button>
			</a-upload>
			<a-button icon="cloud-upload" type="primary" :loading="importLoading" :disabled="fileList.length == 0"
							style="margin: 1.25rem 0;" @click="importSubmit">
				开始上传
			</a-button>
		</vxe-modal>
	</div>
</template>

<script>
	import MeterReadHistory from '../components/MeterReadHistory.vue' 
	export default{
		components:{
			MeterReadHistory,
		},
		data(){
			return {
				importLoading:false,
				fileList:[],
				showImportFlag:false,
				theApId:null,
				list:[],
				gprsList:[],
				collectorList:[],
				neighborList:[],
				selectedRow:[],
				theNeighbor:undefined,
				theGprs:{},
				theCollector:{},
				showUpdateReadFlag:false,
				loading:false,
				showHistoryFlag:false,
				updateSubmitFlag:false,
				chooseFailFlag:false,
				neighborSubmitFlag:false,
				collectorSubmitFlag:false,
				chosedSubmitFlag:false,
				allSubmitFlag:false,
				allFlag:false,
				finishLoading:false,
				singleSubmiting:false,
				lihuOnly:false,
				theUpdateMeterRead:null,
				theObj:{},
				exportTypeList:[],
				departId:null,
				theSearchTitle:'',
				showSearchFlag:false,
				searchSubmitFlag:false,
				searchText:'',
				searchType:0,
				sortList:[
					{
						name:'按房号搜索',
						id:1,
					},
					{
						name:'按给水号搜索',
						id:2,
					},
					{
						name:'按用户名搜索',
						id:3,
					},
					{
						name:'只看当前集中器',
						id:4,
					},
					{
						name:'只看当前集中器和采集器',
						id:5,
					},
					{
						name:'只看故障表',
						id:6,
					},
					{
						name:'查看全部',
						id:0,
					},
				]
			}
		},
		methods:{
			importSubmit(){
				this.importLoading = true;
				const formData = new FormData();
				formData.append('file', this.fileList[0]);
				formData.append("neighborId",this.theNeighbor.key);
				let url = this.Api.getLastUrl(this.Api.READ_METER_DATA_CONTRAST_URL);
				this.Api.fetchPostWithFiles(url,formData).then((data)=>{
					this.importLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("数据上传成功");
						this.queryData();
						this.showImportFlag = false;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.importLoading = false;
					console.log(error);
				});
			},
			beforeUpload:function(file){
				let flag  = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				if(flag){
					this.fileList = [];
					this.fileList = [...this.fileList, file];
				}else{
					this.$message.error('只能上传Excel文件');
				}
				return false;
			},
			handleFileRemove:function(file){
				const index = this.fileList.indexOf(file);
				const newFileList = this.fileList.slice();
				newFileList.splice(index, 1);
				this.fileList = newFileList;
			},
			getTheNeighborName({cellValue}){
				let result = null;
				for(var i=0;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(item.pId == cellValue){
						result = item.neighborName;
						break;
					}
				}
				
				return result;
			},
			queryDataByApId(){
				if(this.theApId == null || this.theApId.length == 0){
					this.$message.error('请输入给水号');
					return ;
				}
				let param = {
					apId:this.theApId
				};
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_LIST_BY_APID_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
				
				
			},
			checkSearch(){
				if(this.searchType == 4 || this.searchType == 5 || this.searchType == 6){
					let  e = {key:this.searchType};
					this.searchIt(e);
				}
			},
			doSearchIt:function(){
				if(this.searchText==null||this.searchText.length==0){
					this.$message.error('请输入关键字');
					return ;
				}
				this.searchSubmitFlag = true;
				let temp = [];
				if(this.searchType == 1){
					for(var i=0;i<this.list.length;i++){
						let obj = this.list[i];
						if(obj.customerNum.indexOf(this.searchText)!=-1){
							temp.push(obj);
						}
					}
				}else if(this.searchType == 2){
					for(var i=0;i<this.list.length;i++){
						let obj = this.list[i];
						if(obj.APID.indexOf(this.searchText)!=-1){
							temp.push(obj);
						}
					}
				}else if(this.searchType == 3){
					for(var i=0;i<this.list.length;i++){
						let obj = this.list[i];
						if(obj.CustomerName.indexOf(this.searchText)!=-1){
							temp.push(obj);
						}
					}
				}
				this.searchSubmitFlag = false;
				this.showSearchFlag = false;
				this.loading = true;
				this.$refs.mTable.reloadData(temp);
				this.loading = false;
			},
			getSearchNamebyId:function(id){
				let result = null;
				for(var i = 0;i<this.sortList.length;i++){
					let obj = this.sortList[i];
					if(obj.id==id){
						result =  obj.name;
						break;
					}
				}
				return result;
			},
			searchIt:function(e){
				this.searchType = e.key;
				switch(e.key){
					case 0:{
						this.loading = true;
						this.$refs.mTable.reloadData(this.list);
						this.loading = false;
					}
					break;
					case 1:
					case 2:
					case 3:{
						this.searchText = '';
						let name = this.getSearchNamebyId(e.key);
						this.theSearchTitle = name;
						this.showSearchFlag = true;
					}
					break;
					case 4:{
						if(Object.keys(this.theGprs).length == 0){
							this.$message.error('请选择集中器');
							return ;
						}
						let temp = [];
						this.loading = true;
						for(var i=0;i<this.list.length;i++){
							let obj = this.list[i];
							if(obj.GPRSAddr == this.theGprs.label){
								temp.push(obj);
							}
						}
						this.$refs.mTable.reloadData(temp);
						this.loading = false;
					}
					break;
					case 5:{
						if(Object.keys(this.theGprs).length == 0||Object.keys(this.theCollector).length == 0){
							this.$message.error('请选择集中器或采集器');
							return ;
						}
						let temp = [];
						this.loading = true;
						for(var i=0;i<this.list.length;i++){
							let obj = this.list[i];
							if(obj.GPRSAddr == this.theGprs.label && obj.CollectorAddr == this.theCollector.label){
								temp.push(obj);
							}
						}
						this.$refs.mTable.reloadData(temp);
						this.loading = false;
					}
					break;
					case 6:{
						let temp = [];
						this.loading = true;
						for(var i=0;i<this.list.length;i++){
							let obj = this.list[i];
							if(obj.MeterState !=1){
								temp.push(obj);
							}
						}
						this.$refs.mTable.reloadData(temp);
						this.loading = false;
					}
					break;
				}
				
			},
			openValve:function(row){
				let state = 0;
				if(row.ValveState==0){
					state = 1;
				}
				let url = this.Api.getLastUrl(this.Api.SET_METER_VALVE_STATE_URL);
				let param = {meterId:row.MID,state:state};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
						this.queryListData();
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			refreshOneMeter:function(taskId){
				let url = this.Api.getLastUrl(this.Api.READ_METER_REFRESH_METER_URL);
				let param = {taskId:taskId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						if (result.type == "5"){
							let read = result.readData/100;
							this.theObj.readdata = read.toFixed(2);
						}else if(result.type == "3"){
							let read = result.readData/1000;
							this.theObj.readdata = read.toFixed(3);
						}else if(result.type == "4"){
							this.theObj.readdata = result.extraReadData;
						}
						else{
							this.theObj.readdata = result.readData;
						}
						this.theObj.readtime = result.readTime;
						this.theObj.MeterState = result.meterState;
						this.$refs.mTable.reloadRow(this.theObj,null);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			selectAllEvent ({ checked, records }) {
				if(checked){
					for(var i = 0;i<records.length;i++){
						this.selectedRow.push(records[i].MID);
					}
				}else{
					this.selectedRow = [];
				}
			},
			selectChangeEvent({ checked, records }) {
				this.selectedRow = [];
				for(var i = 0;i<records.length;i++){
					this.selectedRow.push(records[i].MID);
				}
			},
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(column.property == 'CustomerBalance'){
					if(row.CustomerBalance<=0){
						 style =  {
							 backgroundColor: '#ffee00',
							 color: '#ff0000',
							 fontFamily:"arial,sans-serif",
						 }
					}else{
						style = {
								'color':'#000',
								fontFamily:"arial,sans-serif"
						}	
					}
				} else if(column.property == 'MeterState'){
					if(row.MeterState !=1  ){
						style = {
								backgroundColor: '#ffee00',
								color: '#ff0000'
						}
					}else{
						style = {
								color:'#000',
								fontFamily:"arial,sans-serif"
						}	
					}
				} else if(column.property == 'readdata'){
					style = {
						'font-weight':'bold',
					}
				}else if(column.property == 'readtime'){
					if(row.readtime != null){
						let date = new Date(row.readtime);
						let mytime = new Date().getTime();     //获取当前时间
						let days = Math.floor((mytime - date.getTime()) / (24 * 3600 * 1000));
						if (days >= 15) {
								style = {
									'backgroundColor':'#1E90FF',
									'color':'#FFFFFF',
							}	
						}else{
							style = {
									'color':'#000',
									fontFamily:"arial,sans-serif"
							}
						}
					}
				}else if(this.selectedRow.includes(row.MID)){
					style =  {
						backgroundColor: '#FFE48A',
					}
				}else if(column.property == 'contrastData'){
					if(row.contrastData<0){
						style =  {
							'color':'#ff0000',
						}
					}else{
						style =  {
							'color':'#000',
						}
					}
					
				}
				else{
					style = {
							'color':'#000',
							fontFamily:"arial,sans-serif"
					}	
				}	
				return style;
			},
			lihuCheck:function(e){
				this.lihuOnly = e.target.checked;
				this.queryListData();
			},
			readHistory:function(item){
				this.theObj = this.Config.deepClone(item);
				this.showHistoryFlag = true;
			},
			updateMeterRead:function(){
				if(this.theUpdateMeterRead !=null){
					this.updateSubmitFlag = true;
					let url = this.Api.getLastUrl(this.Api.READ_METER_UPDATE_READ_URL);
					let param = {meterId:this.theObj.MID,read:this.theUpdateMeterRead};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.updateSubmitFlag = false;
						let code = data.data.code;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.cancelUpdateMeterRead();
							this.$message.success('表读数修改成功');
							this.queryData();  
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.updateSubmitFlag = false;
						console.log(error);
					});
				}else{
					this.$message.error('请输入要修改的表读数');
				}
				
			},
			cancelUpdateMeterRead:function(){
				this.showUpdateReadFlag = false;
				this.theUpdateMeterRead = null;
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getFaultFormatter({cellValue}){
				return cellValue == '1'?'是':'否';
			},
			editReadData:function(item){
				this.theObj = this.Config.deepClone(item);
				this.showUpdateReadFlag = true;
			},
			readMeterSingle:function(item){
				this.theObj = item;
				this.singleSubmiting = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_4_SINGLE_URL);
				let param = {meterId:this.theObj.MID};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.singleSubmiting = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
						this.queryListData();
					}
				}).catch((error)=>{
					this.singleSubmiting = false;
					console.log(error);
				});
			},
			readMeter4Chosed:function(){
				if(this.selectedRow.length == 0){
					this.$message.error('请选择表');
				}else if(this.selectedRow.length>100){
					this.$message.error('抄选中表一次不能超过100');
				}else{
					this.chosedSubmitFlag = true;
					let meterIds =  this.selectedRow.join(",");
					let url = this.Api.getLastUrl(this.Api.READ_METER_4_CHOSED_URL);
					let param = {meterIds:meterIds};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.chosedSubmitFlag = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success(msg);
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.chosedSubmitFlag = false;
						console.log(error);
					});
				}
			},
			readMeter4Neighbor:function(){
				this.neighborSubmitFlag = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_4_NEIGHBOR_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.neighborSubmitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.neighborSubmitFlag = false;
					console.log(error);
				});
			},
			checkAllLoading:function(){
				if(this.allFlag ){
					this.allFlag = false;
				}
			},
			readMeter4All:function(){
				this.allSubmitFlag = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_4_ALL_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.allSubmitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.allFlag = true;
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.checkAllLoading();
					this.allSubmitFlag = false;
					console.log(errorr);
				});
			},
			checkReadMeter4Collector:function(){
				if(this.theNeighbor == undefined || this.theNeighbor == null){
					this.$message.error('请选择小区');
					return false;
				}
				if(Object.keys(this.theGprs).length == 0){
					this.$message.error('请选择集中器');
					return false;
				}
				if(Object.keys(this.theCollector).length == 0){
					this.$message.error('请选择采集器');
					return false;
				}
				return true;
			},
			readMeter4CollectorHistory:function(){
				if(this.checkReadMeter4Collector()){
					this.collectorSubmitFlag = true;
					let url =  this.Api.getLastUrl(this.Api.READ_METER_4_COLLECTOR_URL);
					let param = {neighborId:this.theNeighbor.key,gprsAddr:this.theGprs.label,collectorAddr:this.theCollector.label,inTime:'0'};
					this.Api.fetchPost(url,param).then((data)=>{
						this.collectorSubmitFlag = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success(msg);
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.collectorSubmitFlag = false;
						console.log(error);
					});
				}
			},
			readMeter4Collector:function(){
				if(this.checkReadMeter4Collector()){
					this.collectorSubmitFlag = true;
					let url =  this.Api.getLastUrl(this.Api.READ_METER_4_COLLECTOR_URL);
					let param = {neighborId:this.theNeighbor.key,gprsAddr:this.theGprs.label,collectorAddr:this.theCollector.label};
					this.Api.fetchPost(url,param).then((data)=>{
						this.collectorSubmitFlag = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success(msg);
						}else{
							this.$message.error(msg);
							this.queryListData();
						}
					}).catch((error)=>{
						this.collectorSubmitFlag = false;
						console.log(error);
					});
				}
			},
			exportNeighbor:function(e){
				let type = e.key;
				let url = null;
				let fileName = null;
				//导出Excel
				if(type == 0){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_EXCEL_URL);
					fileName = this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.xls';
				} else if(type == -1){//导出Zip
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_ZIP_URL);
					fileName = this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.zip';
				}else if((type == 1) || (type == 4)){  //烟台市立户导出   烟台总立户导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_YT_URL);
					fileName =this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.dbf';
				}else if((type == 2)){//荣成导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_RC_URL);
					fileName =this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.xls';
					
				}else if(type == 3){//福山自来水导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_FS_URL);
					fileName =this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.xls';
				}else if(type == 5){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_WH_URL);
					fileName =this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.xls';
				}else if(type == 6){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_NEIGHBOR_EXCEL_URL);
					fileName = this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.xlsx';
				}
				
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label,lihuOnly:this.lihuOnly?'1':'0'};
				this.Api.fetchPostFile(url,param).then((res)=>{
					console.log(res.data);
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					console.log(error);
				});
			},
			exportAll:function(e){
				this.loading = true;
				let type = e.key;
				let url = null;
				let fileName =  null;
				//导出Excel
				if(type == 0){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_ALL_EXCEL_URL);
					fileName = this.Config.formatDate(new Date)+'全部记录'+'.xls';
				}else if(type == -1){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_ALL_URL);
					fileName = this.Config.formatDate(new Date)+'.zip';
				} else if((type == 1)){  //烟台市立户导出   烟台总立户导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_YT_ALL_URL);
					fileName =this.Config.formatDateShortly(new Date)+"全部记录"+'.dbf';
				}else if((type == 2)){//荣成导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_RC_ALL_URL);
					fileName =this.Config.formatDateShortly(new Date)+"全部记录"+'.xls';
				}else if(type == 3){//福山自来水导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_FS_ALL_URL);
					fileName =this.Config.formatDateShortly(new Date)+"全部记录"+'.xls';
				}else if (type == 4){//烟台总立户导出
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_YT_TOTAL_URL);
					fileName =this.Config.formatDateShortly(new Date)+"全部记录"+'.zip';
				}else if(type == 5){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_WH_ALL_URL);
					fileName =this.Config.formatDateShortly(new Date)+"全部记录"+'.xls';
				}else if(type == 6){
					url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_ALL_EXCEL_URL);
					fileName = this.Config.formatDate(new Date)+'全部记录'+'.xlsx';
				}
				this.Api.fetchPostFile(url).then((res)=>{
					this.loading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download =fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});	
			},
			queryData:function(){
				this.theGprs = {},
				this.theCollector = {},
				this.queryListData();
				this.queryGprs();
			},
			queryListData:function(){
				if(this.theNeighbor == undefined || this.theNeighbor == null){
					return ;
				}
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_LIST_URL);
				let param = {neighborId:this.theNeighbor.key,lihu:this.lihuOnly?'1':'0'};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
						this.checkSearch();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryGprs:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_GPRS_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.gprsList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			queryMeters:function(){
				this.theCollector = {};
				let url = this.Api.getLastUrl(this.Api.READ_METER_METER_LIST_URL);
				let param = {gprsId:this.theGprs.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.collectorList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			queryFailList:function(){
				if(this.list.length > 0){
					this.chooseFailFlag = !this.chooseFailFlag;
					if(this.chooseFailFlag){
						let temp = [];
						let rows = [];
						for(var i=0;i<this.list.length;i++){
							let item = this.list[i];
							if(item.MeterState!=1 && item.MeterState !=5){
								temp.push(item.MID);
								let row = this.$refs.mTable.getRowById(item.MID);
								rows.push(row);
							}
						}
						this.selectedRow = temp;
						this.$refs.mTable.setCheckboxRow(rows, true);
						this.$message.success('共'+this.selectedRow.length+'块故障表');
					}else{
						this.selectedRow = [];
						this.$refs.mTable.setAllCheckboxRow(false);
					}
				}else{
					this.$message.warning('没有可选数据');
				}
				
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			exportData:function(item){
				this.theObj = this.Config.deepClone(item);
				let url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_HISTORY_URL);
				let param = {meterId:item.MID,customerNum:item.customerNum,neighborName:this.theNeighbor.label};
				this.Api.fetchPostFile(url,param).then((res)=>{
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = this.theNeighbor.label+'['+item.customerNum+']'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					console.log(error);
				});
			},
			finishTask:function(){
				this.finishLoading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_FINISH_TASK_MANUAL_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.finishLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.finishLoading = false;
					console.log(error);
				});
			},
			getExportTypeList:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_EXPORT_TYPE_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.exportTypeList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created(){
			this.queryNeighbors();
			this.getExportTypeList();
			this.departId = this.Config.getUserLocal().departmentId;
		},
		computed:{
			check4All:function(){
					let user = this.Config.getUserLocal();
					if(user.wcId == 4){
						return false;
					}else{
						return true;
					}
			},
		},
	}
</script>

<style>
</style>
